import { OverlayModal } from "goi_common";
import { Box } from "@chakra-ui/react";
import { useOverlay } from "@toss/use-overlay";
import { ColorIcon, HStack, Spacing, colors, customEvent } from "goi_common";
import React, { useMemo } from "react";
import ParlorRegionDiscountModalContent from "../ParlorRegionDiscountModalContent";
import parlors_discount from "@/constants/parlors_discount_detail.json";
import { ParlorDetailProps } from "@/types/parlor";

export default function DiscountParlorCTA({
  name,
  sido,
  sigungu,
  sidoName,
  parlors,
}: {
  name: string;
  sidoName: string;
  sido: string;
  sigunguName?: string;
  sigungu?: string;
  parlors?: ParlorDetailProps[];
}) {
  const overlay = useOverlay();

  const discountParlors = useMemo(() => {
    if (sigungu) {
      if (sidoName === "부산" || sidoName === "경남" || sidoName === "울산") {
        return parlors?.map((p) => ({
          parlor_id: Number(p.id),
          sido: p.sido,
          sigungu: p.sigungu,
          description: "20%이상 할인받을 수 있어요(빈소 여유가 있는 경우)",
          memo: p.companyname,
        }));
      }
      return parlors_discount.filter((p) => p.sigungu === String(sigungu));
    } else {
      if (sidoName === "부산" || sidoName === "경남" || sidoName === "울산") {
        return parlors?.map((p) => ({
          parlor_id: Number(p.id),
          sido: p.sido,
          sigungu: p.sigungu,
          description: "20%이상 할인받을 수 있어요(빈소 여유가 있는 경우)",
          memo: p.companyname,
        }));
      }
      return parlors_discount.filter((p) => p.sido === String(sido));
    }
  }, [sido, sigungu, name]);
  return (
    <>
      {discountParlors && discountParlors.length > 0 && (
        <Box
          background={colors.warmGray100}
          padding="36px 24px"
          textAlign="center"
          className="body_16_m gray800"
          borderRadius="12px"
          boxShadow="0px 0px 12px rgba(0, 0, 0, 0.12)"
        >
          {name}에는 빈소이용료를 <b>최대 50% 할인</b>받을 수 있는
          <br />
          고이 제휴 장례식장이 {discountParlors.length}곳 있어요.
          <Spacing gap={48} />
          <HStack alignItems="center" justifyContent="center" gap="40px">
            <HStack
              as="button"
              alignItems="center"
              justifyContent="center"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_region",
                    trigger_and_target: "check_discount-open_modal",
                  },
                });

                overlay.open(({ isOpen, close: onClose }) => {
                  return (
                    <OverlayModal
                      onClose={onClose}
                      isOpen={isOpen}
                      modalContentStyle={{
                        minWidth: "325px",
                      }}
                      overlayModalContent={
                        <ParlorRegionDiscountModalContent
                          onClose={onClose}
                          regionName={name}
                          discountParlors={discountParlors}
                        />
                      }
                      header={{
                        content: <ParlorRegionDiscountModalContent.header onClose={onClose} />,
                      }}
                      footer={{
                        content: <ParlorRegionDiscountModalContent.footer onClose={onClose} />,
                      }}
                    />
                  );
                });
              }}
            >
              <div className="subtitle_14_b orange700">빈소 할인 알아보기</div>
              <ColorIcon
                name="arrow_forward"
                size={10}
                color={colors.orange650}
                css={{ marginLeft: "10px" }}
              />
            </HStack>

            <HStack
              as="button"
              alignItems="center"
              justifyContent="center"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_region",
                    trigger_and_target: "list-tab_list",
                  },
                });
              }}
            >
              <div className="subtitle_14_b orange700">전체 목록에서 확인하기</div>
              <ColorIcon
                name="arrow_forward"
                size={10}
                color={colors.orange650}
                css={{ marginLeft: "10px" }}
              />
            </HStack>
          </HStack>
        </Box>
      )}
    </>
  );
}
